/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dl_Linux_S2Inputs */

const en_wc_dl_linux_s2 = /** @type {(inputs: Wc_Dl_Linux_S2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debian / Ubuntu: install the .deb with apt.`)
};

/**
* | output |
* | --- |
* | "Debian / Ubuntu: install the .deb with apt." |
*
* @param {Wc_Dl_Linux_S2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dl_linux_s2 = /** @type {((inputs?: Wc_Dl_Linux_S2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dl_Linux_S2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dl_linux_s2(inputs)
});
export { wc_dl_linux_s2 as "wc.dl.linux.s2" }